const orderObject = {
  OrderHeader: {
    OrderPK: "",
    OrderNumber: "",
    SplitNumber: "0",
    OrderStatus: "",
    OrderStatusDescription: "",
    OrderCurrencyCode: "",
    OrderDate: "",
    OrderExWorksRequiredBy: "",
    OrderDeliveryRequiredBy: "",
    OrderConfirmDate: "",
    OrderConfirmNumber: "",
    OrderInvoiceDate: "",
    OrderInvoiceNumber: "",
    OrderServiceLevelcode: "",
    OrderServiceLevelDescription: "",
    OrderTransportMode: "",
    OrderContainerMode: "",
    OrderIncoTerm: "",
    OrderCountryOfOrigin: "",
    OrderBuyerPK: "",
    OrderBuyerCode: "",
    OrderBuyerAddressPK: "",
    OrderBuyerAddress1: "",
    OrderBuyerDeliveryAddressPK: "",
    OrderBuyerDeliveryAddress1: "",
    OrderBuyerContactName: "",
    OrderBuyerContactPK: "",
    OrderSupplierPK: "",
    OrderSupplierCode: "",
    OrderSupplierAddressPK: "",
    OrderSupplierAddress1: "",
    OrderSupplierContactName: "",
    OrderSupplierContactPK: "",
    OrderSendingAgentPK: "",
    OrderSendingAgentCode: "",
    OrderReceivingAgentCode: "",
    OrderReceivingAgentPK: "",
    OrderPreAdviceId: "",
    OrderGoodsDescription: "",
    OrderAdditionalTerms: "",
    OrderSpecialInstruction: "",
    OrderActualVolume: "",
    OrderUnitOfVolume: "m3",
    OrderActualWeight: "",
    OrderUnitOfWeight: "kg",
    OrderChargeableWeight: "",
    OrderUnitOfChargeableWeight: "kg",
    PlanningCollection: [],
    OrderContainerCollection: [],
  },
  OrderLinesCollection: [],
  OrderMilstonesCollection: [],
  OrderPlanningCollection: [],
  OrderDocumentsCollection: [],
  OrderNotesCollection: [],
};
export default orderObject;
